import { render, staticRenderFns } from "./FinancialReport.vue?vue&type=template&id=baff5138"
import script from "./FinancialReport.vue?vue&type=script&lang=js"
export * from "./FinancialReport.vue?vue&type=script&lang=js"
import style0 from "./FinancialReport.vue?vue&type=style&index=0&id=baff5138&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports